import React from "react";
import Button from "../form/Button";
import Modal from "../elements/Modal";
import { t } from "i18next";

const DeleteModal = ({
  open = false,
  onClose = () => {},
  deleteHandler = () => {},
  loading = false,
  customMessage,
  deleteButtonIcon,
  titleIcon,
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={() => onClose()}
      title={t("Delete Record")}
      size="sm"
      modaltitleClasses={"!text-slate-200 text-[15px]"}
      headerClass={"!bg-black !rounded-t-lg !text-white"}
      childrenClasses={"!rounded-b-lg"}
      titleIcon={titleIcon}
      titleClass="!text-white"
    >
      <div className="text-center mb-3 text-slate-500">
        {customMessage ? (
          customMessage
        ) : (
          <>{t("Confirm permanent record deletion")}.</>
        )}
      </div>
      <div className="flex gap-2 justify-center">
        <Button
          buttonIconPosition={"left"}
          buttonIcon={"fa-regular fa-close !text-sm"}
          buttonLabel={t("Cancel")}
          buttonFunction={() => onClose()}
          variant="secondary"
        />
        <Button
          buttonFunction={(e) => {
            e.stopPropagation(); // prevent bubbling to parent
            e.preventDefault();
            deleteHandler(e);
          }}
          buttonIconPosition={"left"}
          isDisable={loading}
          isLoaderDisabled={true}
          buttonIcon={
            loading
              ? "fa-duotone fa-spinner-third animate-spin"
              : deleteButtonIcon || "fa-regular fa-trash-can !text-sm"
          }
          buttonLabel={t("Delete")}
          variant="primary"
        />
      </div>
    </Modal>
  );
};

export default DeleteModal;
